import { CommitmentSourcesService_commitmentSourcesServiceGetCommitments } from '@festina/life-general-types/life/hooks/CommitmentSourcesCommitmentsService_commitmentSourcesServiceGetCommitments'

export const useFetchCommitment =
  CommitmentSourcesService_commitmentSourcesServiceGetCommitments.useSuspenseQuery
